import { productService } from '../../services';
import queryString from 'query-string'
import dynamic from 'next/dynamic'
import { serverLocationDetector } from '../../utils/locationDetector';
import sorts from '../../config/sorts';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { MY_LOCATION } from '../../helpers/constTypes';
const Layout = dynamic(() => import('../../components/_App/Layout'))
const Products = dynamic(() => import('../../templates/Products'))



const CardsListContainerWithSidebar = dynamic(() => import('../../components/_App/CardsListContainerWithSidebar'))


export default function CategoryProductsLayout(props){

    const [ brandFilterItems, setBrandFilterItems ] = useState([])
    const [ loadingBrands, setLoadingBrands ] = useState(true)
    const [ loadedAllBrands, setLoadedAllBrands ] = useState(false)

    const getBrandFilters = async (all, search) => {
        try {
            setLoadingBrands(true)
            const location = Cookies.get(MY_LOCATION)
            const { latitude, longitude} = JSON.parse(location)
            const response = await productService.getLocationFilter('brands', '?'+`${all ? 'all=true&' : ''}`+`${search ? 'searchBrand='+search+'&' : ''}`+queryString.stringify({latitude, longitude, boundingRadius:'80467'}))
            setBrandFilterItems(response.totalData)
            all && setLoadedAllBrands(true)
            setLoadingBrands(false)
        } catch (er) {
            console.log(er)
        }
    }

    useEffect(() => {
        getBrandFilters()
    }, [])

    return (
        <Layout
            isAppleMobile = {props.isAppleMobile}
            seo={{
                description: `Discover products available near you from local cannabis retailers.`,
                image: '/static/icons/favicon.png',
                title: "Available Products Near Me | Weedzly",
                url:`https://weedzly.com/products`
            }}
        >
            <Products
                {...props}
                asyncFilters = {[
                    {
                        label: 'Brands',
                        filterfield: 'brand', 
                        field: 'brand',
                        items: brandFilterItems,
                        loading: loadingBrands,
                        icon: 'tag',
                        type: 'eq',
                        loadedAllBrands: loadedAllBrands,
                        multi:true,
                        searchEnabled:true,
                        getAll: (all, search)=>getBrandFilters(all, search)
                    }
                ]}
            >
            </Products>
        </Layout>
    )

}


export async function getServerSideProps(context){

    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )
    if(!context.query.sortField && !context.query.sortOrder){
        let defatultSort = sorts.productsPage[0].opts.find(x => x.default)
        context.query.sortField = defatultSort.sortField
        context.query.sortOrder =  defatultSort.sortOrder
    }
    let query = queryString.stringify(context.query)
    let locationQuery = await serverLocationDetector(context)
    locationQuery = {
        ...locationQuery,
        boundingRadius: 80467
    }
    query = query + '&' + queryString.stringify(locationQuery)
    
    let [ products ] = await Promise.all([
        productService.getPaginated(`?${query}`),
    ])

    return {
        props: {
            isAppleMobile,
            products: products, 
            contextQuery: context.query,
            link: `/products`,
            linkAs: `/products`,
            query: `?${queryString.stringify(context.query)}`
        }
    } 
}